import { shape, string } from 'prop-types';
import React from 'react';
import { Redirect } from 'react-router-dom';

function RedirectToEdit({ location }) {
  return (
    <Redirect
      to={{
        ...location,
        pathname: location.pathname.replace(/\/show$/, '/edit'),
      }}
    />
  );
}

RedirectToEdit.propTypes = {
  location: shape({ pathname: string }).isRequired,
};

export default RedirectToEdit;
